import { ID } from '@datorama/akita';
import { TipoUtente } from '../costanti';

export type SessioneUtente = {
  id: ID;
  nome: string;
  email: string;
  primo_login: number;
  token: string;
  tipo_utente: TipoUtente;
  token_corsi: string;
  privacy?: boolean | number;
  id_sezione_regionale?: number;
  url_img_profilo?: string | null;
  bypassCanDeactivate?: boolean;
};
export function createSession(utente) {
  if (!utente) {
    return null;
  }
  return {
    id: (utente as any).id, //guid(),
    nome: (utente as any).nome,
    email: (utente as any).email,
    primo_login: (utente as any).primo_login,
    token: (utente as any).token,
    tipo_utente: (utente as any).tipo_utente,
    token_corsi: (utente as any).token_corsi,
    privacy: (utente as any).privacy,
    id_sezione_regionale: (utente as any).id_sezione_regionale,
    bypassCanDeactivate: (utente as any).bypassCanDeactivate,
    url_img_profilo: (utente as any).url_img_profilo
  };
}
